var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigmaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2601_14075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33675 20C5.17675 20 6.67008 18.5066 6.67008 16.6666V13.3333H3.33675C1.49675 13.3333 0.00341797 14.8266 0.00341797 16.6666C0.00341797 18.5066 1.49675 20 3.33675 20Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00341797 10C0.00341797 8.16002 1.49675 6.66669 3.33675 6.66669H6.67008V13.3334H3.33675C1.49675 13.3334 0.00341797 11.84 0.00341797 10Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00341797 3.33333C0.00341797 1.49333 1.49675 0 3.33675 0H6.67008V6.66667H3.33675C1.49675 6.66667 0.00341797 5.17333 0.00341797 3.33333Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66992 0H10.0033C11.8433 0 13.3366 1.49333 13.3366 3.33333C13.3366 5.17333 11.8433 6.66667 10.0033 6.66667H6.66992V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3366 10C13.3366 11.84 11.8433 13.3334 10.0033 13.3334C8.16326 13.3334 6.66992 11.84 6.66992 10C6.66992 8.16002 8.16326 6.66669 10.0033 6.66669C11.8433 6.66669 13.3366 8.16002 13.3366 10Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 13.34,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLogo);
export default __webpack_public_path__ + "static/media/FigmaLogo.6fe12a4f2f5d4f1622a39cfddc6852f0.svg";
export { ForwardRef as ReactComponent };